module.exports = __webpack_public_path__ + "static/media/sandvik_logotype_black_rgb.ea82b379.svg";